import { css, CSSResult } from 'lit'
import { csColorBackground, csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csShadow } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'


export const cseToast = {
  backgroundColor: css`var(--cse-toast-background-color, ${csColorBackground.primary})`,
  borderRadius: css`var(--cse-toast-border-radius, ${csBorder.radiusSubtle})`,
  boxShadow: css`var(--cse-toast-box-shadow, ${csShadow.default})`,
  color: css`var(--cse-toast-color, ${csColorText.body})`,
  gap: css`var(--cse-toast-gap, ${csSpacing.spacing06})`,
  paddingInline: css`var(--cse-toast-padding-x, ${csSpacing.spacing06})`,
  paddingBlock: css`var(--cse-toast-padding-y, ${csSpacing.spacing05})`,

  errorColor: css`var(--cse-toast-error-color, ${csColorFunctional.error})`,
  infoColor: css`var(--cse-toast-info-color, ${csColorFunctional.info})`,
  successColor: css`var(--cse-toast-success-color, ${csColorFunctional.success})`,
  warningColor: css`var(--cse-toast-warning-color, ${csColorFunctional.warning})`,
}

export const style: CSSResult = css`
  .cse-toast {
    background-color: ${cseToast.backgroundColor};
    border-radius: ${cseToast.borderRadius};
    box-shadow: ${cseToast.boxShadow};
    gap: ${cseToast.gap};
    display: flex;
    padding-block: ${cseToast.paddingBlock};
    padding-inline: ${cseToast.paddingInline};
    
    @media(min-width: ${SCREENS.small}) {
      align-items: center;
    }
  }

  .title {
    --cse-text-color: ${cseToast.color};
  }

  .content {
    gap: ${cseToast.gap};
    display: flex;
    flex-direction: column;
    margin-right: auto;

    @media(min-width: ${SCREENS.small}) {
      align-items: center;
      flex-direction: row;
    }
  }

  .title {
    display: inline-block;
    flex: 1;
  }

  .variant-error .icon {
    color: ${cseToast.errorColor};
  }
  
  .variant-info .icon {
    color: ${cseToast.infoColor};
  }

  .variant-success .icon {
    color: ${cseToast.successColor};
  }

  .variant-warning .icon {
    color: ${cseToast.warningColor};
  }
`
